import React, { useEffect, useState } from "react";
import { AFFILIATE_DATA } from "./affiliateLink_list";

const getRandomPair = (data, lastPair) => {
  const length = data.length;
  if (length === 0) return [];

  let pair = [];

  while (true) {
    const first = Math.floor(Math.random() * length);
    let second = Math.floor(Math.random() * length);
    while (second === first) second = Math.floor(Math.random() * length);

    pair = [data[first], data[second]];

    if (
      !lastPair ||
      pair[0].title !== lastPair[0].title ||
      pair[1].title !== lastPair[1].title
    ) {
      break;
    }
  }

  return pair;
};

const AffiliateLinks = () => {
  const [currentLinks, setCurrentLinks] = useState([]);
  const [fade, setFade] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // 画面幅チェック
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 1200);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 初回ランダム
  useEffect(() => {
    setCurrentLinks(getRandomPair(AFFILIATE_DATA, null));
  }, []);

  // 10秒ごと切替（フェード）
  useEffect(() => {
    const timer = setInterval(() => {
      setFade(true);
      setTimeout(() => {
        setCurrentLinks((prev) => getRandomPair(AFFILIATE_DATA, prev));
        setFade(false);
      }, 500);
    }, 10000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="affiliate-links-container">
      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row", // ← 縦横切替
          gap: "20px",
          marginTop: "10px",
          opacity: fade ? 0 : 1,
          transition: "opacity 0.5s ease",
        }}
      >
        {currentLinks.map((link, idx) => (
          <a
            key={idx}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "flex",
              flexDirection: "column",
              
              border: "1px solid #ccc",
              borderRadius: "8px",
              background: "#fff",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              width: isMobile ? "100%" : "45%", // ← 横幅切替
              textDecoration: "none",
              color: "inherit",
            }}
          >
            {/* コメント */}
            <p
              style={{
                fontSize: isMobile ? "12px" : "20px",
                textAlign: "center",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                margin: "8px",
                background: "linear-gradient(135deg, #7ac1ff, #68d3f7)",
                padding: "10px",
                borderRadius: "4px",
                color: "#fff",
              }}
            >
              {link.comment || "あの商品が\n今だけこの価格で！？"}
            </p>

            {/* 画像 */}
            {link.image && (
              <img
                src={link.image}
                alt={link.title}
                style={{
                  width: "100%",
                  height: isMobile ? "80px" : "100px",
                  objectFit: "contain",
                  marginBottom: "8px",
                }}
              />
            )}

            {/* 商品名 */}
            <p
              style={{
                fontSize: isMobile ? "12px" : "14px",
                fontWeight: "bold",
                textAlign: "center",
                backgroundColor: "#f5f5f5",
                padding: "8px",
                borderBottom: "1px solid #ddd",
              }}
            >
              {link.title}
            </p>
          </a>
        ))}
      </div>
    </div>
  );
};

export default AffiliateLinks;
